const DIDAPISERVERIP = import.meta.env.VITE_DID_API_SERVER_IP;
const DIDKEY = import.meta.env.VITE_DID_KEY;

const RTCPeerConnection = (window.RTCPeerConnection || window.webkitRTCPeerConnection || window.mozRTCPeerConnection).bind(window);

let peerConnection;
let streamId;
let sessionId;
let sessionClientAnswer;
let talkVideo;
let pcDataChannel;

export const DIDConnect = async (thisTalkVideo, disconnect = false) => {
    talkVideo = thisTalkVideo;
    if (peerConnection && peerConnection.connectionState === "connected" && !disconnect) {
        console.log("DIDConnect already connected... exit");
        return;
    }
    stopAllStreams();
    closePC();

    const sessionResponse = await fetch(`${DIDAPISERVERIP}/talks/streams`, {
        method: "POST",
        headers: { Authorization: `Basic ${DIDKEY}`, "Content-Type": "application/json" },
        body: JSON.stringify({
            source_url: "https://i.ibb.co/h2BHM0z/new-dsara-smile.jpg"
        })
    });

    const { id: newStreamId, offer, ice_servers: iceServers, session_id: newSessionId } = await sessionResponse.json();
    streamId = newStreamId;
    sessionId = newSessionId;

    try {
        sessionClientAnswer = await createPeerConnection(offer, iceServers);

        const sdpResponse = await fetch(`${DIDAPISERVERIP}/talks/streams/${streamId}/sdp`, {
            method: "POST",
            headers: { Authorization: `Basic ${DIDKEY}`, "Content-Type": "application/json" },
            body: JSON.stringify({ answer: sessionClientAnswer, session_id: sessionId })
        });

        return pcDataChannel;
    } catch (e) {
        console.log("error during streaming setup", e);
        stopAllStreams();
        closePC();
        // eslint-disable-next-line no-throw-literal
        throw "all d-id stopped";
    }
};

export const DIDTalkAudioURL = async audioURL => {
    if (peerConnection?.signalingState === "stable" || peerConnection?.iceConnectionState === "connected") {
        await fetch(`${DIDAPISERVERIP}/talks/streams/${streamId}`, {
            method: "POST",
            headers: { Authorization: `Basic ${DIDKEY}`, "Content-Type": "application/json" },
            body: JSON.stringify({
                script: {
                    type: "audio",
                    audio_url: audioURL
                },
                driver_url: "bank://lively/",
                config: {
                    stitch: true
                },
                session_id: sessionId
            })
        }).then(response => {
            if (response.status >= 400 && response.status < 600) {
                throw new Error("no streamId..");
            }
            return response;
        });
    } else {
        console.log("no peer connection... ", peerConnection);
        throw new Error("no peer connection..");
    }
};

export const DIDTalk = async text => {
    if (peerConnection?.signalingState === "stable" || peerConnection?.iceConnectionState === "connected") {
        console.log("DDTalk all good ", peerConnection);
        const talkResponse = await fetch(`${DIDAPISERVERIP}/talks/streams/${streamId}`, {
            method: "POST",
            headers: { Authorization: `Basic ${DIDKEY}`, "Content-Type": "application/json" },
            body: JSON.stringify({
                script: {
                    type: "text",
                    input: text,
                    provider: {
                        type: "microsoft"
                    }
                },
                driver_url: "bank://lively/",
                config: {
                    stitch: true
                },
                session_id: sessionId
            })
        }).then(response => {
            if (response.status >= 400 && response.status < 600) {
                throw new Error("no streamId..");
            }
            return response;
        });
    } else {
        console.log("no peer connection... ", peerConnection);
        throw new Error("no peer connection..");
    }
};

export const DIDdestroy = async () => {
    await fetch(`${DIDAPISERVERIP}/talks/streams/${streamId}`, {
        method: "DELETE",
        headers: { Authorization: `Basic ${DIDKEY}`, "Content-Type": "application/json" },
        body: JSON.stringify({ session_id: sessionId })
    });
    stopAllStreams();
    closePC();
};

function onIceGatheringStateChange() {
    //    iceGatheringStatusLabel.innerText = peerConnection.iceGatheringState;
    //    iceGatheringStatusLabel.className = "iceGatheringState-" + peerConnection.iceGatheringState;
}
function onIceCandidate(event) {
    // console.log("onIceCandidate", event);
    if (event.candidate) {
        const { candidate, sdpMid, sdpMLineIndex } = event.candidate;

        fetch(`${DIDAPISERVERIP}/talks/streams/${streamId}/ice`, {
            method: "POST",
            headers: { Authorization: `Basic ${DIDKEY}`, "Content-Type": "application/json" },
            body: JSON.stringify({ candidate, sdpMid, sdpMLineIndex, session_id: sessionId })
        });
    }
}
function onIceConnectionStateChange() {
    if (peerConnection.iceConnectionState === "failed" || peerConnection.iceConnectionState === "closed") {
        stopAllStreams();
        closePC();
    }
}
function onTrack(event) {
    //console.log("onTrack ", talkVideo);
    const remoteStream = event.streams[0];
    setVideoElement(remoteStream);
}

export async function createPeerConnection(offer, iceServers) {
    if (!peerConnection) {
        peerConnection = new RTCPeerConnection({ iceServers });
        peerConnection.addEventListener("icegatheringstatechange", onIceGatheringStateChange, true);
        peerConnection.addEventListener("icecandidate", onIceCandidate, true);
        peerConnection.addEventListener("iceconnectionstatechange", onIceConnectionStateChange, true);
        peerConnection.addEventListener("connectionstatechange", onConnectionStateChange, true);
        peerConnection.addEventListener("signalingstatechange", onSignalingStateChange, true);
        peerConnection.addEventListener("track", onTrack, true);
        pcDataChannel = peerConnection.createDataChannel("JanusDataChannel");
    }

    await peerConnection.setRemoteDescription(offer);
    // console.log("set remote sdp OK");

    const sessionClientAnswer = await peerConnection.createAnswer();
    // console.log("create local sdp OK");

    await peerConnection.setLocalDescription(sessionClientAnswer);
    // console.log("set local sdp OK");

    return sessionClientAnswer;
}

export function setVideoElement(stream) {
    if (!stream) return;
    talkVideo.srcObject = stream;

    // safari hotfix
    if (talkVideo.paused) {
        talkVideo
            .play()
            .then(_ => {})
            .catch(e => {});
    }
}

export function stopAllStreams() {
    if (talkVideo && talkVideo.srcObject) {
        console.log("stopping video streams");
        talkVideo.srcObject.getTracks().forEach(track => track.stop());
        talkVideo.srcObject = null;
    }
}

/**
 * Uploads an audio file to the DID API server.
 *
 * @async
 * @param {ArrayBuffer} audioArrBuff - The audio file as an ArrayBuffer.
 * @returns {Promise<string>} - A Promise that resolves with the URL of the uploaded audio file.
 */
export async function DIDUploadFile(audioArrBuff) {
    const audioBlob = new Blob([audioArrBuff], { type: "audio/wav" });
    const audioFile = new File([audioBlob], "tts_audio.wav", { type: "audio/wav" });
    const formData = new FormData();
    formData.append("audio", audioFile);
    return await fetch(`${DIDAPISERVERIP}/audios`, {
        method: "POST",
        headers: { Authorization: `Basic ${DIDKEY}`, accept: "application/json" },
        body: formData
    })
        .then(response => response.json())
        .then(response => {
            console.log("response.url", response.url, response);
            return response.url;
        })
        .catch(err => console.error(err)); // TODO: handle error
}

export function closePC(pc = peerConnection) {
    if (!pc) return;
    console.log("stopping peer connection");
    pc.close();
    pc.removeEventListener("icegatheringstatechange", onIceGatheringStateChange, true);
    pc.removeEventListener("icecandidate", onIceCandidate, true);
    pc.removeEventListener("iceconnectionstatechange", onIceConnectionStateChange, true);
    pc.removeEventListener("connectionstatechange", onConnectionStateChange, true);
    pc.removeEventListener("signalingstatechange", onSignalingStateChange, true);
    pc.removeEventListener("track", onTrack, true);
    //    iceGatheringStatusLabel.innerText = "";
    //    signalingStatusLabel.innerText = "";
    //    iceStatusLabel.innerText = "";
    //    peerStatusLabel.innerText = "";
    console.log("stopped peer connection");
    if (pc === peerConnection) {
        peerConnection = null;
    }
}

function onConnectionStateChange() {}
function onSignalingStateChange() {}
